import Vue from 'vue'
import Vuex from 'vuex'

import app from './module/app'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    app
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js